import React from "react";
import { useInView, useMotionValue, animate } from "framer-motion";

/**
 * Counter that animates from 0 to target when scrolled into view.
 * value: number
 * prefix / suffix: strings appended around number
 * decimals: number of decimals
 * duration: seconds
 */
export default function AnimatedCounter({
  value,
  prefix = "",
  suffix = "",
  decimals = 0,
  duration = 1.6,
  className = "",
  testId,
}) {
  const ref = React.useRef(null);
  const inView = useInView(ref, { once: true, margin: "-10% 0px" });
  const mv = useMotionValue(0);
  const [display, setDisplay] = React.useState("0");

  React.useEffect(() => {
    if (!inView) return;
    const controls = animate(mv, value, {
      duration,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (latest) => {
        setDisplay(
          latest.toLocaleString(undefined, {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
          })
        );
      },
    });
    return () => controls.stop();
  }, [inView, value, duration, decimals, mv]);

  return (
    <span ref={ref} className={className} data-testid={testId}>
      {prefix}
      {display}
      {suffix}
    </span>
  );
}
